import { render, staticRenderFns } from "./AssignmentListModal.vue?vue&type=template&id=49a7185e&"
import script from "./AssignmentListModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentListModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentListModal.vue?vue&type=style&index=0&id=49a7185e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports